import { combineReducers } from "redux";

import { userReducer } from "./user";
import { theaterReducer } from "./theater";
import { loadingReducer } from "./loading";
import { scoreReducer } from "./score";
import { modalReducer } from "./modal";
import { selectedCharactersReducer } from "./selectedCharacters";
import { squadSubmissionReducer } from "./squadSubmission";

export default combineReducers({
  user: userReducer,
  theater: theaterReducer,
  loading: loadingReducer,
  score: scoreReducer,
  modal: modalReducer,
  selectedCharacters: selectedCharactersReducer,
  squadSubmission: squadSubmissionReducer,
});
